@if (actionDef.isVisible()) {
  <div class="nav-button-frame" [class.nav-button-frame-active]="active">
    <mat-list-item style="height: 52px" (click)="executeAction.emit(actionDef)">
      <mng-icon
        matListItemAvatar
        style="margin-right: 20px"
        color="white"
        [iconName]="actionDef.getIconName()"
        [fontSize]="28"
      />
      <span fxFlex>{{ actionDef.getTitle() }}</span>
    </mat-list-item>
    @if (showSubanv()) {
      <mat-nav-list style="padding-top: 0">
        @for (subActionDef of actionDef.menu; track subActionDef) {
          @if (subActionDef.isVisible()) {
            <mat-list-item
              [disabled]="subActionDef.isDisabled()"
              (click)="!subActionDef.isDisabled() ? executeAction.emit(subActionDef) : null"
            >
              <div
                fxLayout="row"
                fxLayoutAlign="start center"
                [class]="{ active: isActiveRoute(subActionDef), inactive: !isActiveRoute(subActionDef) }"
              >
                <mng-icon
                  style="margin-right: 20px; padding-left: 24px"
                  class="subnav-icon"
                  matListItemAvatar
                  [iconName]="subActionDef.getIconName()"
                  [fontSize]="28"
                />
                <span>
                  {{ subActionDef.getTitle() }}
                </span>
                @if (subActionDef.externalUrlTarget === '_blank') {
                  <mng-icon
                    style="margin-left: 4px"
                    iconName="open-in-new"
                    class="subnav-icon"
                    [inline]="true"
                    [fontSize]="16"
                  />
                }
              </div>
            </mat-list-item>
          }
        }
      </mat-nav-list>
    }
  </div>
}
